const singeltonleLog = (message: string, cond?: boolean) => {
  if (cond) {
    console.log('currentValues :>> ', message);
  }
};

const uniqIdGenerator = (str: string) => {
  return typeof str == 'string' ? str.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase() : str;
};

const sanitizeZipcode = (item, key) => {
  if (!item?.[key]) {
    return item;
  }
  item[key] = String(item[key])?.trim()?.split('-')[0] || item;
  return item;
};

export { singeltonleLog, uniqIdGenerator, sanitizeZipcode };
